import { html } from "lit";
import { isMp4Media, resolvedMediaUrl } from "../media-utils";

export function renderQuestion({ q, selected, onSelect, readOnly = false }) {
    if (!q) return html`<div class="text-gray-500">Brak pytania.</div>`;

    // najpierw patrzymy na q.kind (dla exam-app), a dopiero potem fallback na correct (dla quiz-app)
    const isTF =
        q.kind === "tf" ||
        q.kind === "boolean" ||
        q.correct === "T" ||
        q.correct === "N";

    const options = isTF ? ["T", "N"] : ["A", "B", "C"];

    const mediaTpl = () => {
        if (!q.media) return null;

        const raw = q.media;
        const src = resolvedMediaUrl(raw);

        if (/\.(jpg|jpeg|png|gif)$/i.test(raw)) {
            return html`
                <div class="overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
                    <img
                            src="${src}"
                            alt="Ilustracja do pytania"
                            class="max-h-72 w-full object-contain"
                    />
                </div>
            `;
        }

        if (isMp4Media(raw)) {
            return html`
                <div class="overflow-hidden rounded-xl border border-gray-200 bg-black/5">
                    <video class="w-full rounded-xl" src="${src}" controls></video>
                </div>
            `;
        }

        return null;
    };

    return html`
        <div class="space-y-5">
            <!-- Nagłówek -->
            <div class="space-y-3">
                <div class="flex flex-wrap items-center gap-2">
                    ${q.nr
                            ? html`
                                <span
                                        class="inline-flex h-7 px-3 items-center justify-center rounded-full bg-primary text-white text-[11px] font-semibold"
                                >
                  #${q.nr}
                </span>
                            `
                            : null}

                    ${q.section
                            ? html`
                                <span
                                        class="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-[11px] font-medium text-gray-600"
                                >
                  ${q.section}
                </span>
                            `
                            : null}
                </div>

                <h2 class="text-xl font-semibold leading-snug text-gray-900">
                    ${q.question}
                </h2>
            </div>

            ${mediaTpl()}

            <!-- Odpowiedzi -->
            <div
                    class="${isTF
                            ? "grid grid-cols-1 sm:grid-cols-2"
                            : "grid grid-cols-1 md:grid-cols-3"} gap-3"
            >
                ${options.map((opt) => {
                    const isSelected = selected === opt;

                    /* ------------------------------
                       NOWY UKŁAD TYLKO DLA TAK/NIE
                       Wyśrodkowany tekst + ikonka z lewej
                    --------------------------------*/
                    if (isTF) {
                        const label = opt === "T" ? "TAK" : "NIE";

                        return html`
                            <button
                                    type="button"
                                    @click=${readOnly ? null : () => onSelect(opt)}
                                    class="
                  relative rounded-xl border h-20 px-4
                  flex items-center justify-center gap-3
                  text-lg font-semibold transition
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60
                  ${isSelected
                                            ? "border-primary bg-primary text-white shadow-sm"
                                            : "border-gray-200 bg-white hover:border-primary/40 hover:bg-primary-50 text-gray-900"}
                "
                            >
                                <!-- Ikonka po lewej -->
                                <span
                                        class="absolute left-4 flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold
                  ${isSelected
                                                ? "border-white/80 bg-white/10 text-white"
                                                : "border-primary/20 bg-primary-50 text-primary-700"}"
                                >
                  ${opt}
                </span>

                                <!-- Wyśrodkowany tekst TAK/NIE -->
                                ${label}
                            </button>
                        `;
                    }

                    /* ------------------------------
                       ABC
                    --------------------------------*/
                    const base =
                            "relative flex items-start gap-3 rounded-xl border px-4 py-3 text-left text-sm transition " +
                            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-1";

                    const state = isSelected
                            ? "border-primary bg-primary text-white shadow-sm"
                            : "border-gray-200 bg-white hover:border-primary/40 hover:bg-primary-50";

                    const text = q[opt.toLowerCase()] || "";

                    return html`
                        <button
                                type="button"
                                class="${base} ${state}"
                                @click=${readOnly ? null : () => onSelect(opt)}
                        >
              <span
                      class="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border text-xs font-semibold
                ${isSelected
                              ? "border-white/80 bg-white/10 text-white"
                              : "border-primary/20 bg-primary-50 text-primary-700"}"
              >
                ${opt}
              </span>

                            <span class="flex flex-col">
                <span
                        class="font-medium ${isSelected ? "text-white" : "text-gray-900"}"
                >
                  ${text}
                </span>
              </span>
                        </button>
                    `;
                })}
            </div>
        </div>
    `;
}
